import React, { useEffect, useState, useContext } from "react";
import AuthContext from "../../contexts/AuthContext";
import {
	Button,
	DateBox,
	Dropdown,
	InputBox,
	InputFile,
	LmsLeaveDetails,
} from "../../components";
import { lmsUserRole, lmsUserGender } from "../../data";
import ApiCall from "../../utils/ApiCall";
import { CREATEUSER, BASE_URL } from "../../Constants";
import SweetAlert from "../../utils/SweetAlert";

const CreateUser = () => {
	const { authTokens } = useContext(AuthContext);
	const [userImg, setUserImg] = useState("");
	const [userImgUrl, setUserImgUrl] = useState("");
	const [userName, setUserName] = useState("");
	const [userId, setUserId] = useState("");
	const [userEmail, setUserEmail] = useState("");
	const [userRole, setUserRole] = useState("");
	const [userDesig, setUserDesig] = useState("");
	const [userGender, setUserGender] = useState("");
	const [userDob, setUserDob] = useState("");
	const [userDoj, setUserDoj] = useState("");
	const [userPf, setUserPf] = useState("");
	const [userSickLeave, setUserSickLeave] = useState("");
	const [userCasualLeave, setUserCasualLeave] = useState("");
	const [reportManager, setReportManager] = useState([]);
	const [reportTrain, setReportTrain] = useState([]);
	const [reportTo, setReportTo] = useState([]);
	const [userMang, setUsermang] = useState("");
	const [userTrai, setUserTrai] = useState("");
	const [userToEmp, setUserToEmp] = useState("");
	useEffect(() => {
		fetchData();
	}, []);

	// console.log("gggg", BASE_URL + CREATEUSER);

	const fetchData = async () => {
		try {
			const res = await ApiCall(CREATEUSER, "GET", authTokens, null);
			//console.log("dropdown details", res);
			setReportManager(res.data.report_to);
			setReportTrain(res.data.report_mang);
			setReportTo(res.data.report_to_1);
		} catch (error) {
			console.log("While fetching CREATEUSER api", error);
		}
	};

	useEffect(() => {
		const storedUserImgUrl = localStorage.getItem("image-url");
		if (storedUserImgUrl) {
			setUserImgUrl(storedUserImgUrl);
		}
	}, []);

	const handleImg = (event) => {
		const file = event.target.files[0];
		setUserImg(file);

		const reader = new FileReader();
		reader.onload = () => {
			const url = reader.result;
			setUserImgUrl(url);
			localStorage.setItem("image-url", url);
		};
		reader.readAsDataURL(file);
		//console.log(reader.result);
	};

	const handleRemoveImg = () => {
		setUserImgUrl("");
		localStorage.removeItem("image-url");
	};

	//console.log("url", userImgUrl);

	const handleUname = (event) => {
		event.preventDefault();
		setUserName(event.target.value);
	};

	const handleUid = (event) => {
		event.preventDefault();
		setUserId(event.target.value);
	};

	const hanleUemail = (event) => {
		event.preventDefault();
		setUserEmail(event.target.value);
	};

	const handleUrole = (event) => {
		event.preventDefault();
		setUserRole(event.target.value);
	};

	const handleUdesig = (event) => {
		event.preventDefault();
		setUserDesig(event.target.value);
	};

	const handleUgender = (event) => {
		event.preventDefault();
		setUserGender(event.target.value);
	};

	const handleUdob = (event) => {
		event.preventDefault();
		setUserDob(event.target.value);
	};

	const handleUdoj = (event) => {
		event.preventDefault();
		setUserDoj(event.target.value);
	};

	const handleUpf = (event) => {
		event.preventDefault();
		setUserPf(event.target.value);
	};

	const handleUsick = (event) => {
		event.preventDefault();
		setUserSickLeave(event.target.value);
	};

	const handleUcasual = (event) => {
		event.preventDefault();
		setUserCasualLeave(event.target.value);
	};

	const handleReportManag = (event) => {
		event.preventDefault();
		setUsermang(event.target.value);
	};

	const handleReportTrai = (event) => {
		event.preventDefault();
		setUserTrai(event.target.value);
	};

	const handleReportTo = (event) => {
		event.preventDefault();
		setUserToEmp(event.target.value);
	};

	const handleCreateUser = async (e) => {
		e.preventDefault();

		const formData = new FormData();
		formData.append("profile_pic", userImg);
		formData.append("username", userName);
		formData.append("emp_id", userId);
		formData.append("email", userEmail);
		formData.append("role", userRole);
		formData.append("designation", userDesig);
		formData.append("gender", userGender);
		formData.append("dob", userDob);
		formData.append("doj", userDoj);
		formData.append("pf_no", userPf);
		formData.append("sick", userSickLeave);
		formData.append("casual", userCasualLeave);

		if (userRole && userRole === "EMPLOYEE") {
			formData.append("report_to", userMang);
		}

		if (userRole && userRole === "TRAINEE") {
			formData.append("report_to_three", userTrai);
		}

		if (userRole && userRole === "INTERN") {
			formData.append("report_to_1", userToEmp);
		}

		// console.log("formData values:");
		// for (let pair of formData.entries()) {
		// 	console.log(pair[0], pair[1]);
		// }

		fetch(BASE_URL + CREATEUSER, {
			method: "POST",
			headers: {
				Authorization: "Bearer " + String(authTokens.access),
			},
			body: formData,
		})
			.then((response) => response.json())
			.then((data) => {
				//console.log("data", data);
				SweetAlert({ title: data, icon: "success" });

				setUserCasualLeave("");
				setUserDesig("");
				setUserDob("");
				setUserDoj("");
				setUserEmail("");
				setUserGender("");
				setUserId("");
				setUserImg("");
				setUserImgUrl("");
				setUserName("");
				setUserPf("");
				setUserRole("");
				setUserSickLeave("");

				localStorage.removeItem("image-url");
			})
			.catch((error) => {
				console.error("Error:", error);
				SweetAlert({ title: error, icon: "error" });
			});
	};

	return (
  <div className="w-full px-6 py-6">
    <form onSubmit={handleCreateUser}>

      {/* ✅ SINGLE CONTAINER */}
      <div className="bg-accent rounded-2xl p-6 box-shadow">

        <div className="flex flex-col md:flex-row gap-8">

          {/* ✅ LEFT SIDE → FORM */}
          <div className="w-full md:w-2/3">

            <h3 className="text-md font-semibold uppercase mb-2">
              Basic Details
            </h3>
            <p className="mb-4 text-sm text-gray-400">
              Please fill user details.
            </p>

            <div className="flex flex-col gap-4">

              <InputBox
                value={userName}
                onChange={handleUname}
                type="text"
                placeholder="Employee Name"
              />

              <InputBox
                value={userId}
                onChange={handleUid}
                type="text"
                placeholder="Employee ID"
              />

              <InputBox
                value={userEmail}
                onChange={hanleUemail}
                type="email"
                placeholder="Email"
              />

              <Dropdown
                value={userRole}
                onChange={handleUrole}
                options={lmsUserRole}
				placeholder="Role"
              />

              {userRole === "EMPLOYEE" && (
                <Dropdown
                  value={userMang}
                  onChange={handleReportManag}
                  options={[
                    { value: "", label: "Select Manager" },
                    ...reportTo.map((item) => ({
                      value: item.id,
                      label: item.name,
                    })),
                  ]}
                />
              )}

              <InputBox
                value={userDesig}
                onChange={handleUdesig}
                type="text"
                placeholder="Designation"
              />

              <Dropdown
                value={userGender}
                onChange={handleUgender}
                options={lmsUserGender}
				placeholder="Gender"
              />

              <label className="text-sm text-gray-400">
  Date of Birth
</label>
<DateBox
  value={userDob}
  onChange={handleUdob}
/>

<label className="text-sm text-gray-400">
  Date of Joining
</label>
<DateBox
  value={userDoj}
  onChange={handleUdoj}
/>

              <InputBox
                value={userPf}
                onChange={handleUpf}
                type="number"
                placeholder="PF Number"
              />

              <InputBox
                value={userSickLeave}
                onChange={handleUsick}
                type="number"
                placeholder="Sick Leaves"
              />

              <InputBox
                value={userCasualLeave}
                onChange={handleUcasual}
                type="number"
                placeholder="Casual Leaves"
              />
            </div>
          </div>

          {/* ✅ RIGHT SIDE → IMAGE (INSIDE SAME BOX) */}
          <div className="w-full md:w-1/3 flex flex-col items-center justify-start">

            <h3 className="text-sm mb-3">Profile Picture</h3>

            <div >
              <InputFile
                cancelBtn={handleRemoveImg}
                userImg={userImgUrl}
                onChange={handleImg}
              />
            </div>

          </div>

        </div>
      </div>

      {/* ✅ SUBMIT */}
      <div className="text-center mt-8">
        <Button classname="bg-button px-6 py-2 rounded-lg text-white font-bold">
          Submit
        </Button>
      </div>

    </form>
  </div>
);
};

export default CreateUser;
